import {
	helperObjectToquert,
	helperObjectToquerthistory,
	helperArrayKeyword
} from "../FunctionAction/function.project"
export const getListGlobalProject = (
	ExclusiveStartKey,
	ordering,
	limit = 20
) => `query {
  getListGlobalProject (limit:${limit},
  ExclusiveStartKey:${helperObjectToquert(ExclusiveStartKey)},
  ordering:${ordering},
  sortby:"query_project_sorted_by_last_modified"
  ){
      data{
        project_id
        project_name
        project_source
        research_area
        role_level
        user_id
        video_url
        amount_comment
        created_date
        last_modified
        project_description
        reference_methodUrl
        add_to_my_project
        project_likes
        project_keyword {
            label
            value
        }
        owner
        project_view
      }
      next_token{
        created_date
        soft_deleted
        last_modified
      }
    }
}`

export const getListMyProject = (
	ExclusiveStartKey,
	ordering,
	user_id,
	limit = 20
) => `query {
  getListMyProject (limit:${limit},
  ExclusiveStartKey:${helperObjectToquert(ExclusiveStartKey)},
  ordering:${ordering},
  sortby:"query_project_sorted_by_last_modified",
  byKeyword: "username",
  byValue: "${user_id}"
  ){
    data{
      project_id
      project_name
      project_source
      research_area
      role_level
      user_id
      video_url
      amount_comment
      created_date
      last_modified
      project_description
      reference_methodUrl
      add_to_my_project
      project_likes
      project_keyword {
          label
          value
      }
      owner
      project_view
    }
    next_token{
      user_id
      created_date
      soft_deleted
      last_modified
    }
  }
}`

export const getOtherProject = (
	user_id,
	ExclusiveStartKey,
	limit = 10
) => `query {
  getOtherProject (user_id:"${user_id}",
  ExclusiveStartKey:${helperObjectToquert(ExclusiveStartKey)},
  limit:${limit}
  ){
      data{
        project_id
        project_name
        project_source
        research_area
        role_level
        user_id
        video_url
        amount_comment
        created_date
        last_modified
        project_description
        reference_methodUrl
        add_to_my_project
        project_likes
        project_keyword {
            label
            value
        }
        owner
        project_view
      }
      next_token{
        user_id
        created_date
        soft_deleted
        last_modified
      }
    }
}`

export const getProject = (project_id) => `query {
  getProject(
      project_id: "${project_id}"
  ) {
    data{
      project_id
      project_name
      project_source
      research_area
      role_level
      user_id
      video_url
      amount_comment
      created_date
      last_modified
      project_description
      reference_methodUrl
      add_to_my_project
      project_likes
      project_keyword {
          label
          value
      }
      owner
      project_view
      reference_add_to_my_project {
        project_id
        user_id
      }
    }
  }
}`

export const getProjectOverview = (project_id) => `query {
  getProject(
      project_id: "${project_id}",
      addView:true
  ) {
    data{
      project_id
      project_name
      project_source
      research_area
      role_level
      user_id
      video_url
      amount_comment
      created_date
      last_modified
      project_description
      reference_methodUrl
      add_to_my_project
      project_likes
      project_keyword {
          label
          value
      }
      owner
      project_view
      reference_add_to_my_project {
        project_id
        user_id
      }
    }
  }
}`

export const getRecommendProject = () => `query {
  getRecommendProject(
      ExclusiveStartKey: null,
      limit:100,
      ordering: false,
      sortby: "query_project_sorted_by_last_modified"
  ) {
    data{
      project_id
      project_name
      project_source
      research_area
      role_level
      user_id
      video_url
      amount_comment
      created_date
      last_modified
      project_description
      reference_methodUrl
      add_to_my_project
      project_likes
      project_keyword {
          label
          value
      }
      owner
      project_view
    }
    next_token{
      user_id
      created_date
      soft_deleted
      last_modified
    }
  }
}`

export const getProjecthistory = (project_id) => `query {
  getProject(
      project_id: "${project_id}"
  ) {
    data{
      project_id
      project_name
      user_id
      last_modified
      project_source
      research_area
      project_keyword {
        label
        value
      }
    }
  }
}`

export const getAssignment = (project_id, ExclusiveStartKey) => `query {
  getAssignment(project_id:"${project_id}",
  ExclusiveStartKey:${helperObjectToquert(ExclusiveStartKey)},
  limit:100) {
    data{
      project_id
      assignment_name
      assignment_description
      assignment_id
      params { 
          fixed_model {class,values,label,typeOfCal}
          random_model {class,values,label,typeOfCal}
          residual {class,values,label,typeOfCal}
          y_variate {class,values,label,typeOfCal}
      }
      user_id
      created_date
      last_modified
      assignment_view
      selected_software
    }
    next_token{
      user_id
      created_date
      soft_deleted
      last_modified
    }
  }
}`

export const geteachAssignment = (
	project_id,
	assignment_id,
	ExclusiveStartKey
) => `query {
  getAssignment(project_id:"${project_id}",
  assignment_id:"${assignment_id}",
  ExclusiveStartKey:${helperObjectToquert(ExclusiveStartKey)},
  limit:100) {
    data{
      project_id
      assignment_name
      assignment_description
      assignment_id
      params { 
          fixed_model {class,values,label,typeOfCal}
          random_model {class,values,label,typeOfCal}
          residual {class,values,label,typeOfCal}
          y_variate {class,values,label,typeOfCal}
      }
      user_id
      created_date
      last_modified
      assignment_view
      selected_software
    }
    next_token{
      user_id
      created_date
      soft_deleted
      last_modified
    }
  }
}`

export const getScript = (assignment_id) =>
	`query{
    getScript(assignment_id:"${assignment_id}"){
      name
      script
      path
      script_id
    }
  }`

export const queryProject = (keyword, value, ExclusiveStartKey, user_id) => {
	if (user_id) {
		return `query{
            queryProject(byKeyword:"${keyword}",
            byValue:"${value}",
            user_id:"${user_id}",
            ExclusiveStartKey:${helperObjectToquert(ExclusiveStartKey)}){
              data{
                project_id
                project_name
                project_source
                research_area
                role_level
                user_id
                video_url
                amount_comment
                created_date
                last_modified
                project_description
                reference_methodUrl
                add_to_my_project
                project_likes
                project_keyword {
                    label
                    value
                }
                owner
                project_view
              }
              next_token{
                user_id
                created_date
                soft_deleted
                last_modified
              }
            }
          }`
	}
	return `query{
          queryProject(byKeyword:"${keyword}",
          byValue:"${value}",
          user_id:${user_id},
          ExclusiveStartKey:${helperObjectToquert(ExclusiveStartKey)}){
            data{
              project_id
              project_name
              project_source
              research_area
              role_level
              user_id
              video_url
              amount_comment
              created_date
              last_modified
              project_description
              reference_methodUrl
              add_to_my_project
              project_likes
              project_keyword {
                  label
                  value
              }
              owner
              project_view
            }
            next_token{
              user_id
              created_date
              soft_deleted
              last_modified
            }
          }
        }`
}

export const getUser = (user_id) => `query{
  getUser(user_id:"${user_id}"){
    user_id
    first_name
    last_name
    user_address
    user_company
    provider
    following
    follower
    email
    created_date
    last_modified
    library_list
    phone_number
    profile_picture
    occupation
    research_field
    department
    country
    ip_country
    favorite_project
    accepted_news
  }
}`
export const getComment = (project_id, ExclusiveStartKey) => {
	if (ExclusiveStartKey === null) {
		return `query{
          getComment(
            project_id:"${project_id}",
            ExclusiveStartKey:"",
            limit:4,
            ordering: false
          ) {
            data {
              user_id
              comment_id
              content
              created_date
              project_id
              last_modified
            }
            next_token
          }
        }`
	} else {
		return `query{
          getComment(
            project_id:"${project_id}",
            ExclusiveStartKey:"${ExclusiveStartKey}",
            limit:4,
            ordering: false
          ) {
            data {
              user_id
              comment_id
              content
              created_date
              project_id
              last_modified
            }
            next_token
          }
        }`
	}
}

export const getUserUnAuth = (user_id) => `query{
  getUser(user_id:"${user_id}"){
    first_name
    last_name
    profile_picture
  }
}`

export const getReport = (project_id) => `query{
  getReport(project_id:"${project_id}"){
    product_id
    product_name
    product_type
    price
    preview_report_url
    full_report_url
    project_id
    user_id
    last_modified
    created_date
  }
}`

export const getReportglobalproject = (project_id) => `query{
  getReport(project_id:"${project_id}"){
    project_id
  }
}`

//Advanced Search
export const advancedSearch = ({
	project_name,
	username,
	research_area,
	report,
	video,
	search_value
}) => `query{
  advancedSearch(
    project_name:${project_name},
    username:${username},
    research_area:"${research_area}",
    report:${report},
    video:${video},
    search_value:"${search_value}"
  ) {
    data {
      project_id
      project_name
      project_source
      research_area
      role_level
      user_id
      video_url
      amount_comment
      created_date
      last_modified
      project_description
      reference_methodUrl
      add_to_my_project
      project_likes
      project_keyword {
          label
          value
      }
      owner,
      project_view
    }
    next_token{
      user_id
      created_date
      soft_deleted
      last_modified
    }
  }
}`

export const keywordSearch = (project_keyword) => `query{
  keywordSearch(
    project_keyword:${helperArrayKeyword(project_keyword)}
  ) {
    data {
      project_id
      project_name
      project_source
      research_area
      role_level
      user_id
      video_url
      amount_comment
      created_date
      last_modified
      project_description
      reference_methodUrl
      add_to_my_project
      project_likes
      project_keyword {
          label
          value
      }
      owner
      project_view
    }
    next_token{
      user_id
      created_date
      soft_deleted
      last_modified
    }
  }
}`
export const getRating = (rating_type, project_id, user_id) => {
	if (user_id) {
		return `query{
            getRating(
              rating_type:"${rating_type}",
              project_id:"${project_id}",
              user_id:"${user_id}")
              {
                statusCode
                body
              }
          }`
	} else if (project_id) {
		return `query{
          getRating(
            rating_type:"${rating_type}",
            project_id:"${project_id}",
            user_id:"")
            {
              statusCode
              body
            }
        }`
	} else {
		return `query{
          getRating(
            rating_type:"${rating_type}",
            project_id:"",
            user_id:"")
            {
              statusCode
              body
            }
        }`
	}
}

export const getHistory = ({
	history_action,
	ordering,
	ExclusiveStartKey
}) => `query{
  getHistory(
    history_action:"${history_action}",
    ordering:${ordering},
    ExclusiveStartKey:${helperObjectToquerthistory(ExclusiveStartKey)})
    {
      data{
        history_id
        history_action
        target_action
        subject_id
        history_detail
        created_date
      }
      next_token{
        subject_id
        history_action
        created_date
      }
    }
}`

export const getNotification = (user_id, next_token, limit = 100) => {
	if (!!next_token) {
		return `query{
      getNotification(
        user_id:"${user_id}",
        next_token:"${next_token}",
        limit:${limit},
        )
        {
          data{
            notification_title
            notification_type
            notification_body
            date_time
            notification_id
            user_id
            from
            seen
          }
          next_token
        }
    }`
	} else {
		return `query{
        getNotification(
          user_id:"${user_id}",
          next_token:"",
          limit:${limit},
          )
          {
            data{
              notification_title
              notification_type
              notification_body
              date_time
              notification_id
              user_id
              from
              seen
            }
            next_token
          }
      }`
	}
}

export const getAllBlog = `query{
  getAllBlog(
    ordering: false
  ) {
    data{
      blog_id
      blog_content
      blog_description
      blog_header
      blog_author
      blog_coverImg
      alternate_link
      canonical_link
    }
  }
}`
